/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-10 13:25:48
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-06-15 14:09:27
 * @Description: file content
 */

Vue.component("usercard4", {
  props: {
    my_all_info: Object
  },
  template: `<div class="warp" v-if="isShowUserCard">
    <div class="usercard4" v-if="isShowMyCard&&cardInfo&&cardInfo.ui">
      <div class="top">
        <div class="head">
          <img :src="cardInfo.ui.headimg" alt />
        </div>
        <div class="fields">
          <div class="field">
            <span v-if="isInMiniProgram" class="value company">
              <span>{{cardInfo.ui.name}}</span>
              <span>{{' '+cardInfo.ui.company}}</span>
            </span>
            <span v-else class="value company company-web">
              <span>{{cardInfo.ui.name}}</span>
              <span>{{' '+cardInfo.ui.company}}</span>
            </span>
          </div>
          <div class="field">
            <span class="label">电话</span>
            <span class="value">
              <a :href="'tel:'+cardInfo.ui.mobile">{{cardInfo.ui.mobile}}</a>
            </span>
          </div>
          <div class="field" v-if="cardInfo.ui.wechat">
            <span class="label">微信</span>
            <span class="value">{{cardInfo.ui.wechat}}</span>
          </div>
        </div>
      </div>
      <div class="usercard4_bottom hide">如是AI智慧营销—领先的AI获客神器，{{count}}人正在使用，包括{{count2}}位您的好友，如是AI智慧营销内置多种裂变获客工具，还有AI助理帮你找客户</div>
      <div v-if="isInMiniProgram" class="btn" @click="clickChangeMy">立即使用</div>
      <img
        v-if="!isInMiniProgram&&qrcode"
        class="qrcodeimg"
        :src="qrcode"
        alt
      />
    </div>
  </div>`,
  data() {
    return {
      isShowUserCard: false,
      isShowMyCard: false,
      cardInfo: null,
      qrcode: "",
      isInMiniProgram: false,
      count: 0,
      count2: 0
    };
  },
  methods: {
    clickChangeMy() {

    },
    initCardShowHide() {
      var that = this;
      if (myPageData.Other.PageUserSetting) {
        if (myPageData.Other.PageUserSetting.cardhidden == 0) {
          that.isShowMyCard = true;
        } else if (myPageData.Other.PageUserSetting.cardhidden == 1) {
          that.isShowMyCard = false;
        }
      } else {
        that.isShowMyCard = true;
      }
    },
  },
  created() {
    console.log("cardinfo444", JSON.parse(JSON.stringify(this.my_all_info)));
    if (myTemp.rscuid || (this.my_all_info.userIntegralInfo && this.my_all_info.userIntegralInfo.isSale)) {
      this.cardInfo = this.my_all_info.fansInfo;
      this.qrcode = myTemp.qwQrCodeUrl || this.my_all_info.qrcode;
      this.isShowUserCard = true;
      this.isShowMyCard = true;
    }
    this.count = util.randomNum(1000000, 2000000);
    this.count2 = util.randomNum(10, 100);
    this.initCardShowHide();
    if (window.cfg.subdomian == "tyry") {
      this.isShowUserCard = false;
    }
  },
  mounted() {
    $("#myusercard42").html($("#myusercard41"));
  }
});
